import React from 'react';
import { Box, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, Chip } from '@mui/material';
import { formatCurrency } from '../DrillDown/formatters';

interface Cliente {
  nome: string;
  cnpj_cpf: string;
  total_debito_icms: number;
  documentos: number;
  participacao_percentual?: number;
}

interface Cfop {
  cfop: string;
  total_debito_icms: number;
  documentos: number;
}

interface Estatisticas {
  total_debito_icms: number;
  ticket_medio: number;
  total_documentos: number;
  max_nota: number;
  min_nota: number;
}

interface DataResponse {
  periodo: string;
  estatisticas: Estatisticas;
  top_clientes: Cliente[];
  top_cfops: Cfop[];
}

const IcmsDebitosPeriodoDrillDownContent: React.FC<{ data: DataResponse }> = ({ data }) => {
  const { estatisticas, top_clientes, top_cfops } = data;

  return (
    <Box sx={{ p: 2 }}>
      {/* Estatísticas Gerais */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Chip label={`Débito Total: ${formatCurrency(estatisticas.total_debito_icms)}`} color="error" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Chip label={`Ticket Médio: ${formatCurrency(estatisticas.ticket_medio)}`} color="primary" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Chip label={`Notas: ${estatisticas.total_documentos}`} color="info" />
        </Grid>
      </Grid>

      {/* Top Clientes */}
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
        Top Clientes
      </Typography>
      <Table size="small" sx={{ mb: 4 }}>
        <TableHead>
          <TableRow>
            <TableCell>Cliente</TableCell>
            <TableCell>CNPJ/CPF</TableCell>
            <TableCell align="right">Débito ICMS</TableCell>
            <TableCell align="right">Docs</TableCell>
            <TableCell align="right">% Part.</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {top_clientes.map((c) => (
            <TableRow key={c.nome}>
              <TableCell>{c.nome}</TableCell>
              <TableCell>{c.cnpj_cpf}</TableCell>
              <TableCell align="right">{formatCurrency(c.total_debito_icms)}</TableCell>
              <TableCell align="right">{c.documentos}</TableCell>
              <TableCell align="right">{(c.participacao_percentual || 0).toFixed(2)}%</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Top CFOPs */}
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
        Top CFOPs
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>CFOP</TableCell>
            <TableCell align="right">Débito ICMS</TableCell>
            <TableCell align="right">Docs</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {top_cfops.map((c) => (
            <TableRow key={c.cfop}>
              <TableCell>{c.cfop}</TableCell>
              <TableCell align="right">{formatCurrency(c.total_debito_icms)}</TableCell>
              <TableCell align="right">{c.documentos}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default IcmsDebitosPeriodoDrillDownContent; 